/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - Territory Management
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useDealer from "hooks/useDealer";

export default function data() {
  const navigate = useNavigate();
  const { getdealerList, resendInvitation, deleteDealer, dealerList } = useDealer();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({});

  const DealerActions = ({ onEdit, onDelete, onResentinvite, dealerId }) => (
    <MDBox display="flex" justifyContent="center">
      <MDButton
        variant="outlined"
        color="secondary"
        onClick={onResentinvite}
        sx={{ mr: 1 }}
        disabled={loading[dealerId]?.resend}
      >
        {loading[dealerId]?.resend ? "Resending..." : "Resend Invite"}
      </MDButton>
      <MDButton variant="contained" color="info" onClick={onEdit} sx={{ mr: 1 }}>
        <EditIcon />
      </MDButton>
      <MDButton
        variant="contained"
        color="error"
        onClick={onDelete}
        disabled={loading[dealerId]?.delete}
      >
        {loading[dealerId]?.delete ? "..." : <DeleteIcon />}
      </MDButton>
    </MDBox>
  );

  const DealerInfo = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const handleResendInvite = async (dealerId) => {
    if (window.confirm("Are you sure you want to resend the invitation?")) {
      setLoading((prev) => ({ ...prev, [dealerId]: { ...prev[dealerId], resend: true } }));
      try {
        const res = await resendInvitation(dealerId);
        if (res.success) {
          alert("Invitation resent successfully!");
        } else {
          alert("Failed to resend invitation. Please try again.");
        }
      } catch (err) {
        console.error("Error resending invitation:", err);
        alert("An error occurred while resending the invitation.");
      } finally {
        setLoading((prev) => ({ ...prev, [dealerId]: { ...prev[dealerId], resend: false } }));
      }
    }
  };

  const handleDeleteDealer = async (dealerId) => {
    if (window.confirm("Are you sure you want to delete this dealer?")) {
      setLoading((prev) => ({ ...prev, [dealerId]: { ...prev[dealerId], delete: true } }));
      try {
        const res = await deleteDealer(dealerId);
        if (res.success) {
          alert("Dealer deleted successfully!");
          fetchList();
        }
      } catch (err) {
        console.error("Error deleting dealer:", err);
        alert("An error occurred while deleting the dealer.");
      } finally {
        setLoading((prev) => ({ ...prev, [dealerId]: { ...prev[dealerId], delete: false } }));
      }
    }
  };

  const fetchList = async () => {
    await getdealerList();
  };

  useEffect(() => {
    if (dealerList.dealers) {
      setData(dealerList.dealers);
    }
  }, [dealerList]);

  const rows = data?.map((dealer, index) => ({
    name: <DealerInfo key={index} name={dealer.userId?.name} email={dealer?.userId?.email} />,
    phoneNumber: `${dealer?.userId?.countryCode} ${dealer?.userId?.mobile}`,
    bussinessName: dealer?.bussinessName || "N/A",
    gstNo: dealer.gstNo,
    town: dealer.town,
    actions: (
      <DealerActions
        dealerId={dealer._id}
        onEdit={() => navigate(`/dealer-management/edit?id=${dealer._id}`)}
        onDelete={() => handleDeleteDealer(dealer._id)}
        onResentinvite={() => handleResendInvite(dealer._id)}
      />
    ),
  }));

  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Phone Number", accessor: "phoneNumber", align: "left" },
      { Header: "Bussiness Name", accessor: "bussinessName", align: "left" },
      { Header: "GST No", accessor: "gstNo", align: "left" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}
